const style = {
  fontSize: '5vw',
  fontWeight: 'bold',
  margin: 0
}

export const TextSmall = ({ text }: { text: string }) => <h2 style={style}>{text}</h2>
